import { Box, Button, Divider, Flex } from '@mantine/core';
import { useTheme } from 'styled-components';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon';
import { useTranslationCommonUi } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';

interface Props {
	onGoBack: () => void;
}

export const StepHeader = ({ onGoBack }: Props) => {
	const tCommonUi = useTranslationCommonUi();
	const theme = useTheme();

	return (
		<Box px="1rem">
			<Flex direction="column" gap="sm">
				<Button
					variant="subtle"
					leftSection={<Icon variant="arrow-left-v3" />}
					onClick={onGoBack}
					sx={{
						alignSelf: 'flex-start',
						color: theme.v2.color.neutral[1100],
						fontWeight: 600,
						'&:hover': {
							background: 'transparent',
							color: theme.v2.color.secondary[1000],
						},
					}}
				>
					{tCommonUi('common_buttons.back')}
				</Button>
			</Flex>
			<Divider />
		</Box>
	);
};
